<div class="autobuffy-loader" [style.width.px]="width" [style.height.px]="height"></div>